<template>
    <div>
        <FormulateForm
            @submit="login"
        >
            <FormulateInput
                v-model="email"
                type="email"
                label="Your Email"
                name="email"
                validation="required"
                :wrapper-class="['login_email']"
            />
            <FormulateInput
                v-model="password"
                type="password"
                label="Your Password"
                name="password"
                validation="required"
                :wrapper-class="['login_password']"
            />
            <FormulateInput
                type="submit"
                label="Login"
                :wrapper-class="['login_submit']"
            />
        </FormulateForm>
        <p v-if="msg">{{ msg }}</p>
    </div>
</template>

<script>
import axios from 'axios'
import AuthService from '@/services/AuthService.js';

export default {
    name: 'LoginForm',
    data: function(){
        return {
            email: "",
            password: "",
            msg: ""
        }
    },
    methods: {
        async login() {
            try {
                const credentials = {
                    email: this.email,
                    password: this.password
                };
                const response = await AuthService.login(credentials);
                this.msg = response.msg;
                const token = response.token;
                const slug = response.profile.slug;
                this.$store.dispatch('login', {token:token, userSlug:slug});
                //this.$router.push('/');
            } catch (error) {
                this.msg = error.response.data.msg;
                console.log(this.msg)
            }
        }
    }
}
</script>